import { type QConfigInformation } from '@exam-management/feature-qconfig-provider';
import { QConfigStructureCategory } from '@exam-management/graphql';

export function getLOSCombinations(input: {
  chapterId: string;
  qConfigStructures: QConfigInformation['structures'];
  defaultLOS?: string[];
}) {
  const { chapterId, qConfigStructures, defaultLOS } = input;

  const questionTypes = qConfigStructures.filter((structure) => structure.parentId === chapterId);

  return questionTypes.reduce<string[][]>((acc, questionType) => {
    const los = qConfigStructures.filter(
      (structure) =>
        structure.parentId === questionType.id &&
        structure.category === QConfigStructureCategory.LearningObjectiveStatement,
    );

    const combinations = los.map((lo) => lo.refId).filter((code): code is string => !!code);

    const hasCombinations = combinations.length > 0;
    const isSameAsDefaultLOS =
      defaultLOS &&
      combinations.length === defaultLOS.length &&
      combinations.every((code) => defaultLOS.includes(code));

    if (hasCombinations && !isSameAsDefaultLOS) {
      acc.push(combinations);
    }

    return acc;
  }, []);
}
